module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break"
  }, [_c('span', [_vm._v("Part II")])]), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1"
  }, [_c('span')]), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1"
  }, [_c('span', [_vm._v("Deacon")])]), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1"
  }, [_c('span')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3647a882","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0010.vue
// module id = 84
// module chunks = 0